import { Box, Button, Container, Divider, Link, Typography } from "@mui/material"
import SectionSkeleton from "../../../components/ui/SectionSkeleton"
import { Link as NavLink } from "react-router-dom"
import { Fragment, lazy, Suspense } from "react"
import Images from "../../../assets/js/Images"
import "slick-carousel/slick/slick-theme.css"
import "slick-carousel/slick/slick.css"

const CtaSection = lazy(() => import("../../../components/ui/CtaSection"))
const Testimonials = lazy(() => import("./Testimonials"))
const Specialist = lazy(() => import("./Specialist"))
const TopBanner = lazy(() => import("./TopBanner"))
const Services = lazy(() => import("./Services"))
const Workflow = lazy(() => import("./Workflow"))
const Forum = lazy(() => import("./Forum"))
const Blogs = lazy(() => import("./Blogs"))

function Home() {

  return (
    <Fragment>
      <Suspense fallback={<SectionSkeleton />}>
        <TopBanner />
      </Suspense>

      <Suspense fallback={<SectionSkeleton />}>
        <Workflow />
      </Suspense>

      <Suspense fallback={<SectionSkeleton />}>
        <Services />
      </Suspense>

      <Suspense fallback={<SectionSkeleton />}>
        <Specialist />
      </Suspense>

      <Box
        sx={{ py: 5, bgcolor: "secondary.dark" }}
        component="section"
      >
        <Container maxWidth={false} fixed>
          <Box mx="auto" color="white" textAlign="center">
            <Typography
              sx={{
                mb: 1,
                fontSize: "21px",
                fontWeight: "600"
              }}
            >We're here for you. Mail us at
              <Link
                sx={{
                  color: "white",
                  textDecorationColor: "white",
                }}
                underline="hover"
                component={NavLink}
                to="mailto:support@innerpal.com"
              > support@innerpal.com
              </Link> OR request an appointment online.
            </Typography>
            <Typography
              fontSize={19}
            >Conditions our Mental Health Counselors are unable to treat.
            </Typography>
            <Divider
              sx={{
                mt: 2,
                mx: "auto",
                maxWidth: "250px",
                borderWidth: "2px",
                borderColor: "white",
              }}
            />
          </Box>
        </Container>
      </Box>

      <Suspense fallback={<SectionSkeleton />}>
        <Testimonials />
      </Suspense>

      <Suspense fallback={<SectionSkeleton />}>
        <Forum />
      </Suspense>

      <Suspense fallback={<SectionSkeleton />}>
        <Blogs />
      </Suspense>

      <Box
        component="section"
        sx={{ py: 2.5, bgcolor: "#f95858" }}
      >
        <Container maxWidth={false} fixed>
          <Box mx="auto" color="white" textAlign="center">
            <Typography
              sx={{
                fontWeight: "600",
                fontSize: { sm: "18px", md: "20px" },
              }}
            >Call National Emergency Helpline Number Immediately
            </Typography>
          </Box>
        </Container>
      </Box>

      <Suspense fallback={<SectionSkeleton />}>
        <CtaSection bannerImg={Images?.homeCta}>
          <Typography
            variant="ctaNormal"
          >Stay healthy and strong to enjoy life
          </Typography>
          <Typography
            variant="ctaLead"
          >Believe. Consolation. Reality.
          </Typography>
          <Button
            variant="CtaButton"
            to="/find-specialist"
            LinkComponent={NavLink}
          >Find a Specialist
          </Button>
        </CtaSection>
      </Suspense>
    </Fragment>
  )
}

export default Home